export default {"src":"/_next/static/media/Openly-color.e1bd3ce8.svg","height":45,"width":71};